module.exports = __webpack_public_path__ + "media/sg_video_intro.d7d25567.mp4";